// 元素可见时执行操作
function onElementVisible(el, callback) {
  // 判断是否支持 IntersectionObserver
  if ('IntersectionObserver' in window) {
    // 使用 IntersectionObserver 判断元素可见性
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback(entry.target);
          observer.unobserve(entry.target); // 只触发一次可见性事件后取消观察
        }
      });
    });
    // 开始观察目标元素
    if(el) observer.observe(el);
  } else {
    // 对于不支持 IntersectionObserver 的情况，使用 scroll 事件
    function checkVisibility() {
      const rect = el.getBoundingClientRect();
      const inView =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth);

      if (inView) {
        callback(el);
        window.removeEventListener('scroll', checkVisibility); // 取消 scroll 事件监听
      }
    }

    // 初次检查是否可见
    checkVisibility();

    // 监听 scroll 事件
    window.addEventListener('scroll', checkVisibility);
  }
}

function isMobile() {
  return window.innerWidth <= 767 || /Mobi|Android/i.test(navigator.userAgent);
}

// 元素可见时上滑+渐变显示
// 当 showElement 可见时，移动 slideElement
// marginTop 恢复到原来的 marginTop
function slideUpShow(showElement, slideElement, marginTop = '0px') {
  onElementVisible(showElement, () => {
    slideElement.style.marginTop = '300px';
    slideElement.style.opacity = 0;
    setTimeout(() => {
      slideElement.style.opacity = 1;
      slideElement.style.transition = 'margin-top 1.5s ease, opacity 1.5s ease-in-out';
      slideElement.style.marginTop = marginTop;
      setTimeout(() => {
        slideElement.style.transition = '';
      }, 1600);
    }, 100);
  });
}

function formatDate(date) {
  let year = date.getFullYear();
  let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero based
  let day = String(date.getDate()).padStart(2, '0');
  let hours = String(date.getHours()).padStart(2, '0');
  let minutes = String(date.getMinutes()).padStart(2, '0');
  let seconds = String(date.getSeconds()).padStart(2, '0');
  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
}
